import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { Clock, Mail, Building2, RefreshCw, Loader2, CalendarDays } from 'lucide-react';
import Layout from '../../components/Layout';
import api from '../../utils/api';

const Badge = ({ situacao }) => {
  const map = {
    teste:    { txt: 'Em teste', cls: 'bg-amber-50 text-amber-700 border-amber-200' },
    ativo:    { txt: 'Ativo',    cls: 'bg-green-50 text-green-700 border-green-200' },
    expirado: { txt: 'Expirado', cls: 'bg-red-50 text-red-700 border-red-200' },
  };
  const s = map[situacao] || map.expirado;
  return <span className={`text-xs font-bold px-2.5 py-1 rounded-full border ${s.cls}`}>{s.txt}</span>;
};

export default function Cobrancas() {
  const [empresas, setEmpresas] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [enviando, setEnviando] = useState(null);

  const carregar = () => {
    setLoading(true);
    api.get('/admin/cobrancas')
      .then(r => setEmpresas(r.data.empresas || []))
      .catch(() => toast.error('Erro ao carregar cobranças.'))
      .finally(() => setLoading(false));
  };
  useEffect(() => { carregar(); }, []);

  const avisar = async (emp) => {
    setEnviando(emp.id);
    try {
      const { data } = await api.post(`/admin/empresas/${emp.id}/avisar-teste`);
      toast.success(data.mensagem || 'E-mail enviado!');
    } catch (err) {
      toast.error(err.response?.data?.erro || 'Erro ao enviar e-mail.');
    }
    setEnviando(null);
  };

  const alterarPrazo = async (emp) => {
    const dias = window.prompt('Definir prazo de acesso de "' + (emp.razao_social || emp.nome) + '" em dias a partir de hoje (ex: 30, 90, 365):');
    if (dias === null) return;
    const n = parseInt(dias);
    if (!Number.isFinite(n)) { toast.error('Informe um numero de dias valido.'); return; }
    try {
      const { data } = await api.post(`/admin/empresas/${emp.id}/prazo`, { dias: n });
      toast.success(data.mensagem || 'Prazo atualizado!');
      carregar();
    } catch (err) {
      toast.error(err.response?.data?.erro || 'Erro ao alterar prazo.');
    }
  };

  const emTeste   = empresas.filter(e => e.situacao === 'teste').length;
  const ativas    = empresas.filter(e => e.situacao === 'ativo').length;
  const expiradas = empresas.filter(e => e.situacao === 'expirado').length;

  return (
    <Layout title="Cobranças" subtitle="Empresas ativas, planos e período de teste">
      <div className="grid grid-cols-3 gap-3 mb-6">
        <div className="card p-4"><p className="text-xs text-gray-500">Em teste</p><p className="text-2xl font-black text-amber-600">{emTeste}</p></div>
        <div className="card p-4"><p className="text-xs text-gray-500">Pagantes ativas</p><p className="text-2xl font-black text-green-600">{ativas}</p></div>
        <div className="card p-4"><p className="text-xs text-gray-500">Expiradas</p><p className="text-2xl font-black text-red-500">{expiradas}</p></div>
      </div>

      <div className="flex justify-between items-center mb-3">
        <h2 className="font-sora font-bold text-acre-dark">Empresas</h2>
        <button onClick={carregar} className="text-sm text-acre-green flex items-center gap-1 hover:underline"><RefreshCw size={14}/> Atualizar</button>
      </div>

      {loading ? (
        <div className="card p-10 text-center text-gray-400"><Loader2 className="animate-spin mx-auto mb-2"/> Carregando...</div>
      ) : empresas.length === 0 ? (
        <div className="card p-10 text-center text-gray-400">Nenhuma empresa cadastrada.</div>
      ) : (
        <div className="card overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-gray-500 text-xs uppercase">
              <tr>
                <th className="text-left p-3">Empresa</th>
                <th className="text-left p-3">Situação</th>
                <th className="text-left p-3">Plano</th>
                <th className="text-left p-3">Dias restantes</th>
                <th className="text-right p-3">Ação</th>
              </tr>
            </thead>
            <tbody>
              {empresas.map(e => (
                <tr key={e.id} className="border-t border-gray-100">
                  <td className="p-3">
                    <p className="font-semibold text-acre-dark flex items-center gap-1.5"><Building2 size={14} className="text-gray-400"/>{e.razao_social || e.nome}</p>
                    <p className="text-xs text-gray-400">{e.email}</p>
                  </td>
                  <td className="p-3"><Badge situacao={e.situacao}/></td>
                  <td className="p-3 text-gray-600">{e.plano}</td>
                  <td className="p-3">
                    <span className={`inline-flex items-center gap-1 font-bold ${e.dias_restantes<=3?'text-red-500':e.dias_restantes<=7?'text-amber-600':'text-gray-700'}`}>
                      <Clock size={13}/> {e.dias_restantes} dia(s)
                    </span>
                  </td>
                  <td className="p-3 text-right">
                    {e.situacao === 'teste' && (
                      <button onClick={() => avisar(e)} disabled={enviando===e.id}
                        className="text-xs font-semibold bg-acre-green text-white px-3 py-1.5 rounded-lg inline-flex items-center gap-1 disabled:opacity-60">
                        {enviando===e.id ? <Loader2 size={13} className="animate-spin"/> : <Mail size={13}/>} Avisar fim do teste
                      </button>
                    )}
                    <button onClick={() => alterarPrazo(e)}
                      className="text-xs font-semibold bg-acre-dark text-white px-3 py-1.5 rounded-lg inline-flex items-center gap-1 hover:opacity-90 ml-2">
                      <CalendarDays size={13}/> Prazo
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Layout>
  );
}
